/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type PdpRespSidebarBlurbShipping_user = {
    readonly isVerifiedTrade: boolean | null;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedShippingInfoLink_user" | "PdpSharedShippingInfo_user">;
    readonly " $refType": "PdpRespSidebarBlurbShipping_user";
};
export type PdpRespSidebarBlurbShipping_user$data = PdpRespSidebarBlurbShipping_user;
export type PdpRespSidebarBlurbShipping_user$key = {
    readonly " $data"?: PdpRespSidebarBlurbShipping_user$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSidebarBlurbShipping_user">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarBlurbShipping_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isVerifiedTrade",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedShippingInfoLink_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedShippingInfo_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};
(node as any).hash = '6dfdc5d168cdda38559873e63f63a157';
export default node;
